<div class="filters-wrapper {{wrapperClass}}" #wrapper>
    @if (showFilterSection) {
        <button class="filters-wrapper__reset"
                [class.show]="showFilters"
                (click)="toggleFilters()">
            {{ (showFilters ? 'VIATOR.HIDE_FILTERS' : 'VIATOR.SHOW_FILTERS') | translate }}
        </button>
    }
    <div class="filters-wrapper__filters" [class.show]="showFilters && showFilterSection">
        <ng-content select="[filters]"></ng-content>
    </div>
    <div class="filters-wrapper__content" [class.show]="showFilters && showFilterSection">
        <ng-content select="[content]"></ng-content>
    </div>
    <div class="filters-wrapper__map" [class.show]="openedMap">
        @if (openedMap) {
            <button class="filters-wrapper__close" (click)="onCloseMap.emit()">
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                    <circle cx="19.5" cy="20.5" r="19.5"/>
                    <path d="M20.5 41C25.9369 41 31.1512 38.8402 34.9957 34.9957C38.8402 31.1512 41 25.9369 41 20.5C41 15.0631 38.8402 9.84881 34.9957 6.00431C31.1512 2.15982 25.9369 0 20.5 0C15.0631 0 9.84881 2.15982 6.00431 6.00431C2.15982 9.84881 0 15.0631 0 20.5C0 25.9369 2.15982 31.1512 6.00431 34.9957C9.84881 38.8402 15.0631 41 20.5 41ZM28.3396 15.375L26.9783 16.7363L23.2146 20.5L26.9783 24.2637L28.3396 25.625L25.625 28.3396L24.2637 26.9783L20.5 23.2146L16.7363 26.9783L15.375 28.3396L12.6604 25.625L14.0217 24.2637L17.7854 20.5L14.0217 16.7363L12.6604 15.375L15.375 12.6604L16.7363 14.0217L20.5 17.7854L24.2637 14.0217L25.625 12.6604L28.3396 15.375Z"
                          fill="white"/>
                </svg>
            </button>
            <ng-content select="[map]"></ng-content>
        }
    </div>
</div>
